// Module
var code = "<a href=\"#\" role=\"link\" data-hook=\"footer-support-email\" class=\"SupportMessageLink\" ng-click=\"(SupportMessageLink.clickHandler && SupportMessageLink.clickHandler()); SupportMessageLink.contact();\"> {{SupportMessageLink.linkText}} </a> ";
// Exports
var _module_exports = code;;
var path = '@collectivehealth/frontend-member-v2/components/supportMessageLink/supportMessageLink.html';
var angular = require('angular');
angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;